import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

function processImageData(data) {
  const hueBins = []; // 10-degree bins for Hue

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const a = data[i + 3];

    if (a === 0) continue; // Skip transparent pixels

    const rgb = `rgb(${r},${g},${b})`;
    hueBins[rgb] = {
      r: data[i],
      g: data[i + 1],
      b: data[i + 2],
      count: (hueBins[rgb]?.count || 0) + 1,
    };
  }

  return hueBins;
}

const ColorAnalyzer = ({ imageUrl }) => {
  const canvasRef = useRef();
  const svgRef = useRef();

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = imageUrl;

    img.onload = () => {
      // 1. Get pixel data from Canvas
      const ctx = canvasRef.current.getContext("2d");
      const maxDimension = 200;
      let width, height;

      // Calculate dimensions while maintaining aspect ratio
      if (img.width > img.height) {
        width = maxDimension;
        height = (img.height / img.width) * maxDimension;
      } else {
        height = maxDimension;
        width = (img.width / img.height) * maxDimension;
      }

      // Update canvas size to match the new scaled dimensions
      canvasRef.current.width = width;
      canvasRef.current.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      const data = ctx.getImageData(0, 0, width, height).data;

      // 2. Process: Simple binning (e.g., Hue distribution)
      const colorStats = processImageData(data);

      console.log("Pixel data length:", colorStats);
      // 3. D3 Chart logic
      const svg = d3.select(svgRef.current);
      // ... standard D3 selection, enter, update pattern ...
    };
  }, [imageUrl]);

  return (
    <div>
      <canvas
        ref={canvasRef}
        style={{ display: "block" }}
        width="200"
        height="200"
      />
      <svg ref={svgRef} width="500" height="300"></svg>
    </div>
  );
};

export default ColorAnalyzer;
